<template>
    <article class="category-item" :class="{ empty: childrenCount === 0 }">
        <router-link v-if="childrenCount > 0" :to="linkTo" class="category-item-content">
            <h4 class="category-item-title">{{title}}</h4>
            <p class="count">{{childrenCount}} gb</p>
        </router-link>
        <div v-else="" class="category-item-content">
            <h4 class="category-item-title">{{title}}</h4>
            <p class="count">{{childrenCount}} gb</p>
        </div>
    </article>
</template>

<script>
    export default {
        props: {
            'linkTo': Object,
            'title': String,
            'childrenCount': Number,
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";

    .category-item {
        background-color: white;
        border: 1px solid #d7d8da;
        position: relative;
        border-radius: 8px;
        margin-bottom: 0.9375rem * 2; //TODO implement Foundation grid gutters with media queries
        transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

        &.empty {
            background-color: #f6f5f5;
        }

        &:not(.empty):hover {
            box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.3);
            transform: translate(-2px, -5px);
        }

        &:after {
            content: "";
            display: block;
            padding-bottom: 100%;
        }

        .category-item-content {
            text-align: center;
            position: absolute;
            padding: 28px;
            width: 100%;
            height: 100%;
            color: #404141;
            transition: color 0.2s ease-in-out;
            display: flex;
            flex-direction: column;

            &:hover,
            &:active {
                color: darken(#404141, 10%);
            }
        }

        .category-item-title {
            font-size: px-em(36px);
            font-weight: 700;
            width: 100%;
            margin: auto 0 0 0;
        }

        p.count {
            font-size: px-em(18px);
            font-weight: 700;
            margin: auto 0 0 0;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/CategoryTitleItem.vue